module.exports = __webpack_public_path__ + "static/media/validation-delivery.3e150ed4.svg";